import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import { marketingPreferencesUrl } from '../config';
var queryFnFactory = function (config, keyProps) {
    var fetchWrapper = getFetchWrapper(config);
    return function () {
        var params = new URLSearchParams({
            'cipher.accountId': keyProps.accountId
        });
        if (keyProps.accountIdType) {
            params.set('accountIdType', keyProps.accountIdType);
        }
        return fetchWrapper("".concat(marketingPreferencesUrl, "?").concat(params), {
            method: 'GET'
        });
    };
};
export default queryFnFactory;
